<template>
  <div class="cd">
    <TopHead
      :is-bb="true"
      share-name="政务公告"
      :share-text="info.title"
      is-share="true"
    />
    <div class="cd_con">
      <div class="cd_ti">
        {{ info.title }}
      </div>
      <div class="cd_sub">
        来源：{{ info.sourceName }}
      </div>
      <div class="cd_sub d_f ali_c j_s">
        <span>发布时间：{{ info.createDate }}</span>
        <span>{{ info.readNumber }}浏览</span>
      </div>
      <div class="cd_fwb">
        <div v-html="info.content" />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "GmDetail",
    data() {
      return {
        info:{},
      }
    },
    created(){
      this.getInfoContentDetail();
    },
    methods: {
      getInfoContentDetail(){
        this.$api.getInfoContentDetail({contentId:this.$route.query.id}).then(res => {
          this.info = res.data;
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .cd_con{
    .cd_fwb{
      ::v-deep img{
        max-width: 100%;
        height: auto;
      }
      ::v-deep video{
        max-width: 100%;
        height:auto;
      }
      margin-top: 20px;
    }
    .cd_sub{
      margin-bottom: 5px;
      font-size: 24px;
      font-weight: 500;
      color: #6E6E6E;
    }
    .cd_ti{
      margin-bottom: 35px;
      font-size: 36px;
      font-weight: bold;
      color: #3E3E3E;
    }
    padding: 53px 25px 25px;
  }
  .cd{
    overflow: auto;
    box-sizing: border-box;
    height: 100vh;
    padding: 85px 0 99px;
  }

</style>
